import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { IWageGrade, IWageGradeCreateRequest, IWageGradeUpdateRequest } from '../interfaces/payroll.interface';

// Wage grade catalog (decision note 2026-09-08 wage-grades REV 2). Follows the house axios
// service pattern (PayrollService, StatutoryRegisterService).
export const WageGradeService = {
    getByInstitution: async (institutionId?: string): Promise<IWageGrade[]> => {
        const instId = institutionId || AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.WAGE_GRADE.BY_INSTITUTION(instId), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    create: async (data: IWageGradeCreateRequest): Promise<IWageGrade> => {
        const response = await axios.post(ENDPOINTS.WAGE_GRADE.BASE, data, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    update: async (id: string, data: IWageGradeUpdateRequest): Promise<IWageGrade> => {
        const response = await axios.put(ENDPOINTS.WAGE_GRADE.UPDATE(id), data, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    // R1: the opt-in gazette import -- never called automatically.
    seedDefaults: async (institutionId: string): Promise<IWageGrade[]> => {
        const response = await axios.post(ENDPOINTS.WAGE_GRADE.SEED_DEFAULTS(institutionId), {}, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },
};
